import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { useEffect } from 'react';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRole?: 'user' | 'admin';
}

export function PrivateRoute({ children, requiredRole }: PrivateRouteProps) {
  const { isAuthenticated, user, logout } = useAuthStore();
  const location = useLocation();

  // Validate user ID format
  useEffect(() => {
    if (user?.id) {
      const isValidUUID = (uuid: string): boolean => {
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return uuidRegex.test(uuid);
      };
      
      if (!isValidUUID(user.id)) {
        console.error('Invalid user ID format detected in PrivateRoute:', user.id);
        logout();
      }
    }
  }, [user?.id, logout]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check for role-based access if requiredRole is specified
  if (requiredRole && user?.role !== requiredRole) {
    // Redirect to home page if user doesn't have required role
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}